const theme = {
  bgColor: '#CCD3E3',
  textColor: '#222222',
};

export default theme;
